import * as actionType from '../action-type';

export const updateLaminateReport = (data) => ({
  type: actionType.UPDATE_LAMINATE_REPORT,
  payload: data,
});

export const resetLaminateReport = () => ({
  type: actionType.RESET_LAMINATE_REPORT,
});
